import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { selectSortType } from '../../redux/actions';
import { Triangle, slugify, getCategory } from '../../utils';
import { SmallDropdown } from '../../components';
import { Router } from '../../routes';

import { SortTypesContainer, CurrentSortType } from './styles';

const mapStateToProps = state => ({
  market: state.userPreferences.city.market,
  sortType: state.userPreferences.sortType,
  product: state.userPreferences.product,
});

const mapDispatchToProps = dispatch => bindActionCreators({
  handleSortTypeSelection: selectSortType,
}, dispatch);

@connect(mapStateToProps, mapDispatchToProps)
class HotelSort extends Component {
  static propTypes = {
    currentDropdown: PropTypes.string,
    handleSortTypeSelection: PropTypes.func,
    handleDropdownClick: PropTypes.func,
    handleCloseDropdown: PropTypes.func,
    sortType: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    product: PropTypes.string,
    market: PropTypes.string,
  };

  availableSortOptions = {
    0: 'Most Popular',
    1: 'Cheapest',
    2: 'Closest',
  };

  handleSortOptionClick = evt => {
    const { handleSortTypeSelection, handleCloseDropdown, product, market } = this.props;
    const { target } = evt;
    const sortType = target.name;

    Router.pushRoute('search', {
      ...Router.query,
      marketName: slugify(market),
      category: getCategory(product),
      sortType,
    }, { shallow: true });

    handleSortTypeSelection(sortType);
    handleCloseDropdown();
  };

  render() {
    const { availableSortOptions, handleSortOptionClick } = this;
    const { currentDropdown, sortType, handleDropdownClick, handleCloseDropdown } = this.props;

    return (
      <SortTypesContainer>
        <CurrentSortType name="sortType" onClick={handleDropdownClick}>
          {availableSortOptions[sortType]}
          <Triangle width={11} height={7} />
        </CurrentSortType>
        {currentDropdown === 'sortType' && (
          <SmallDropdown onClickOutside={handleCloseDropdown} onOptionClick={handleSortOptionClick} selectedOption={sortType}>
            {Object.keys(availableSortOptions).map(key => (
              <button type="button" key={key} name={key}>
                {availableSortOptions[key]}
              </button>
            ))}
          </SmallDropdown>
        )}
      </SortTypesContainer>
    );
  }
}

export default HotelSort;
